import React from 'react';
import Snackbar from 'material-ui/Snackbar';
import FontIcon from 'material-ui/FontIcon';
import FlatButton from 'material-ui/FlatButton'

const Message = ({message, onClick, icon, iconColor}) => 
    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}> 
        <FontIcon className="material-icons" style={{color: iconColor, display: 'inline-block', verticalAlign: 'middle'}}>{icon}</FontIcon>
        <span>{message}</span>
        <FlatButton style={{color: 'white'}} onClick={onClick}>Dismiss</FlatButton>
    </div>

export default ({messages, resetMessages}) => {
    return(
    <div>
        { messages.errorMessage && <Snackbar 
            message={<Message message={messages.errorMessage} icon="close" iconColor="red" onClick={resetMessages}/> }
            open={messages.errorMessage ? true : false} 
            autoHideDuration={300000} 
            onRequestClose={resetMessages}
        />}
        { messages.successMessage && <Snackbar 
            message={<Message message={messages.successMessage} icon="done" iconColor="green" onClick={resetMessages} />}
            open={messages.successMessage ? true : false} 
            autoHideDuration={300000} 
            onRequestClose={resetMessages}
        />}
    </div>
)}



// WEBPACK FOOTER //
// ./src/components/message/Message.js